// ABOUTME: SPEC-82 — the collection menu's look in one place (row height, type, popover surface, current/other weights),
// ABOUTME: so swapping the menu's styling is one file; geometry is in the authored units of the composition it sits in.

import { RAIL_UNIT } from '../../ReelChrome/railGeometry';
import { MOBILE_UNIT } from '../../ReelChrome/mobileGeometry';

export const MENU = {
  rowH: 88,              // authored; floored at MIN_ROW_PX so a handset row stays a real touch target
  minRowPx: 44,
  font: 37.333,          // reel.text.tagBody
  minFontPx: 12,
  padX: 36,
  gap: 24,               // icon -> label
  iconW: 54,
  popoverGap: 13.333,    // chip -> popover, the rail's own header pitch
  minChipGapPx: 12,      // ...but never closer than the chip's own 44px touch halo (a 29px chip needs 7.5px each side)
  wordmarkGap: 16,       // authored clearance between a mobile popover and the centred wordmark
  radius: 40,            // reel.radius.panel
  currentWeight: 400,    // the current view is NOT bold...
  otherWeight: 700,      // ...the one you can go to is
  disabledOpacity: 0.5,
  watchIconSize: 40,     // lucide Watch, px at the authored scale
};

export const MENU_UNIT = { desktop: RAIL_UNIT, mobile: MOBILE_UNIT };
export const MENU_Z = 80; // inside the rail portal, which already sits at 80
